import innerStreak from '@/assets/images/possibleStreak.svg';
import streak from '@/assets/images/streak.svg';
import styles from './ActiveStreak.module.scss';

const activeStreak = () => {
  return (
    <div className={styles.activeStreakRoot}>
      <img src={streak} alt="Streak" />
      <img src={innerStreak} alt="Inner Streak" className={styles.innerStreak} />
    </div>
  );
};

export default activeStreak;
